/// <reference types="vite-plugin-svgr/client" />
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";
import EmptyCartLT from "@monorepo/assets/src/img/home.svg?react";
import EmptyCartPL from "@monorepo/assets/src/img/homePL.svg?react";
import { StyledPageWrapper, Title } from "@monorepo/components";
import { LANGUAGE } from "@monorepo/constants";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { LanguagesEnum, VoucherProvidersEnum } from "@monorepo/types";
import { reverse } from "named-urls";

import { PageWrapper } from "components/Services/ServicesPage";

import CarInsuranceService from "./CarInsuranceService";
import CharityServices from "./CharityServices";
import FishermanTicketService from "./FishermanTicketService";
import GsmTopUpServices from "./GsmTopUpServices";
import GsmVouchers from "./GsmVouchers";
import GsmVouchersVendors from "./GsmVouchersVendors";
import GsmVoucherVendorGroup from "./GsmVoucherVendorGroup";
import HowToUseGsmVoucher from "./HowToUseGsmVoucher";
import MyGsmVoucher from "./MyGsmVoucher";
import MyGsmVouchers from "./MyGsmVouchers";
import PerlasEnergyService from "./PerlasEnergyService";
import PrepaidElectricityService from "./PrepaidElectricityService";
import ServicesByCategory from "./ServicesByCategory";
import SingleService from "./SingleService";

interface IProps {
  gsmTopUpServiceId?: string;
  charityId?: string;
  vendor?: string;
  voucherId?: string;
  serviceId?: string;
  categoryId?: string;
  ignoreGroup: boolean;
}

export const Services: React.FC<IProps> = ({
  gsmTopUpServiceId,
  ignoreGroup,
  charityId,
  vendor,
  categoryId,
  serviceId,
  voucherId,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Switch>
        {LANGUAGE === LanguagesEnum.LT && (
          <>
            <Route exact path={routeConfig.dashboard.services.fishermanTicket}>
              <FishermanTicketService />
            </Route>
            <Route path={routeConfig.dashboard.services.carInsurance}>
              <CarInsuranceService />
            </Route>
            <Route exact path={routeConfig.dashboard.services.electricity}>
              <PerlasEnergyService />
            </Route>
            <Route exact path={routeConfig.dashboard.services.gsmTopUpServices.self}>
              <GsmTopUpServices />
            </Route>
            <Route path={routeConfig.dashboard.services.gsmTopUpServices.gsmTopUpServiceId}>
              <SingleService id={gsmTopUpServiceId} ignoreGroup={ignoreGroup} />
            </Route>
            <Route exact path={routeConfig.dashboard.services.charityServices.self}>
              <CharityServices />
            </Route>
            <Route path={routeConfig.dashboard.services.charityServices.charityId}>
              <SingleService id={charityId} ignoreGroup={ignoreGroup} />
            </Route>
            {!!categoryId && (
              <>
                {!!serviceId && (
                  <Route path={routeConfig.dashboard.services.category.categoryId.service.serviceId}>
                    <SingleService
                      id={serviceId}
                      ignoreGroup={ignoreGroup}
                      redirectOnServiceGroupSelect={(id) =>
                        reverse(routeConfig.dashboard.services.category.categoryId.service.serviceId, {
                          categoryId: categoryId,
                          serviceId: id,
                        })
                      }
                    />
                  </Route>
                )}
                <Route exact path={routeConfig.dashboard.services.category.categoryId.self}>
                  <ServicesByCategory id={Number(categoryId)} />
                </Route>
              </>
            )}
          </>
        )}
        {LANGUAGE === LanguagesEnum.PL && (
          <>
            {vendor && (
              <Route exact path={routeConfig.dashboard.services.gsmVouchers.buyGsmVoucher.vendor.self}>
                <GsmVoucherVendorGroup vendor={vendor as VoucherProvidersEnum} />
              </Route>
            )}
            {voucherId && (
              <Route path={routeConfig.dashboard.services.gsmVouchers.myVouchers.voucherId}>
                <MyGsmVoucher voucherId={voucherId} />
              </Route>
            )}
            <Route path={routeConfig.dashboard.services.gsmVouchers.buyGsmVoucher.vendor.serviceId}>
              <SingleService id={serviceId} ignoreGroup={ignoreGroup} />
            </Route>
            <Route exact path={routeConfig.dashboard.services.gsmVouchers.buyGsmVoucher.self}>
              <GsmVouchersVendors />
            </Route>
            <Route path={routeConfig.dashboard.services.gsmVouchers.howToUseGsmVoucher}>
              <HowToUseGsmVoucher />
            </Route>
            <Route exact path={routeConfig.dashboard.services.gsmVouchers.myVouchers.self}>
              <MyGsmVouchers />
            </Route>
            <Route exact path={routeConfig.dashboard.services.gsmVouchers.self}>
              <GsmVouchers />
            </Route>
            <Route exact path={routeConfig.dashboard.services.prepaidElectricity}>
              <PrepaidElectricityService />
            </Route>
          </>
        )}
        <Route path={routeConfig.dashboard.services.self}>
          <StyledPageWrapper>
            <PageWrapper hasServiceIcon={false}>
              <Title> {t("navigation.services")}</Title>
              {LANGUAGE === LanguagesEnum.PL && <EmptyCartPL />}
              {LANGUAGE === LanguagesEnum.LT && <EmptyCartLT />}
            </PageWrapper>
          </StyledPageWrapper>
        </Route>
      </Switch>
    </>
  );
};

export default Services;
